/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrimbleDiagnosticsControllerLookupAccountQueryResponse, TrimbleDiagnosticsControllerLookupAccountQueryParams, TrimbleDiagnosticsControllerLookupAccount400, TrimbleDiagnosticsControllerLookupAccount401, TrimbleDiagnosticsControllerLookupAccount403, TrimbleDiagnosticsControllerLookupAccount404 } from "../../models/trimbleDiagnosticsController/TrimbleDiagnosticsControllerLookupAccount";

function getTrimbleDiagnosticsControllerLookupAccountUrl() {
  const res = { method: 'GET', url: `/api/v1/trimble-account-diagnostics` as const }  
  return res
}

/**
 * @summary Resolve a Trimble IAM or CDH account link
 * {@link /api/v1/trimble-account-diagnostics}
 */
export async function trimbleDiagnosticsControllerLookupAccount(params: TrimbleDiagnosticsControllerLookupAccountQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TrimbleDiagnosticsControllerLookupAccountQueryResponse, ResponseErrorConfig<TrimbleDiagnosticsControllerLookupAccount400 | TrimbleDiagnosticsControllerLookupAccount401 | TrimbleDiagnosticsControllerLookupAccount403 | TrimbleDiagnosticsControllerLookupAccount404>, unknown>({ method : "GET", url : getTrimbleDiagnosticsControllerLookupAccountUrl().url.toString(), params, ... requestConfig })  
  return res.data
}